import { Outlet } from "react-router-dom"
import { AppSidebar } from "@/components/app-sidebar"

export const AppShell = () => (
  <div className="flex min-h-screen w-full bg-background">
    <AppSidebar />
    <main className="min-w-0 flex-1 overflow-auto">
      <Outlet />
    </main>
  </div>
)
